import React from "react";
export const Skills = [
  {
    image: "/media/webb.png",
  },
  {
    image: "/media/style.png",
  },
  {
    image: "/media/JAVASCRIPT.png",
  },
  {
    image: "/media/react.png",
  },
  {
    image:"/media/node.png",
    
  },
  {
    image:"/media/mongo.png"
  }
];
